import { Snowflake, Flame, Sun, Wind } from "lucide-react";

export const IMAGES = {
  hero: "https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2",
  solar: "https://images.pexels.com/photos/35726122/pexels-photo-35726122.jpeg",
  heatpump: "https://images.pexels.com/photos/20046693/pexels-photo-20046693.jpeg",
  insulation: "https://images.unsplash.com/photo-1758687126877-b37052a20a4d",
  boiler: "https://images.unsplash.com/photo-1732660513320-a6b489f3fece",
  family: "https://images.unsplash.com/photo-1740679953679-23433eaf3156",
  finance: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85",
};

export const MEASURES = [
  {
    slug: "insulation",
    name: "Insulation",
    icon: Snowflake,
    tagline: "Loft, cavity wall & internal solid wall insulation",
    image: IMAGES.insulation,
    desc: "Stop heat escaping and slash your bills. Proper insulation is the single most cost-effective measure for a warmer, cheaper-to-run home.",
    benefits: ["Up to 35% less heat loss", "Lower energy bills year-round", "Reduced condensation & damp", "Quick, clean installation"],
  },
  {
    slug: "boilers",
    name: "New Boilers",
    icon: Flame,
    tagline: "A-rated, high-efficiency gas boilers",
    image: IMAGES.boiler,
    desc: "Replace an old, inefficient boiler with a modern A-rated unit. Reliable heating and hot water, with significantly lower running costs.",
    benefits: ["Up to 92% efficiency", "Gas Safe registered engineers", "Smart heating controls", "Full manufacturer warranty"],
  },
  {
    slug: "solar-pv",
    name: "Solar PV",
    icon: Sun,
    tagline: "Rooftop solar panels & battery storage",
    image: IMAGES.solar,
    desc: "Generate your own clean electricity and store it for when you need it. Cut your reliance on the grid and protect against rising prices.",
    benefits: ["Generate free electricity", "Battery storage options", "Export & earn from surplus", "25-year panel performance"],
  },
  {
    slug: "heat-pumps",
    name: "Heat Pumps",
    icon: Wind,
    tagline: "Air source heat pump installation",
    image: IMAGES.heatpump,
    desc: "Low-carbon heating that's up to 3x more efficient than a gas boiler. The future of home heating, eligible for major government grants.",
    benefits: ["Up to 300% efficient", "£7,500 grant available*", "Heating & hot water", "Quiet, low-carbon running"],
  },
];

export const FAQS = [
  { q: "Do I really pay nothing upfront?", a: "Yes. For eligible customers we cover installation through a combination of government grants and finance options. Where a grant fully covers a measure, there's nothing to pay. Where finance is used, you spread the cost in affordable monthly payments with no large deposit." },
  { q: "What grants are available?", a: "Depending on your circumstances and property, you may qualify for schemes such as the Boiler Upgrade Scheme (up to £7,500 toward a heat pump), ECO4, and the Great British Insulation Scheme. We check your eligibility for you as part of the free survey." },
  { q: "How does the free survey work?", a: "A qualified surveyor visits your home, assesses your property and current energy use, and recommends the most effective measures. You receive a clear, no-obligation plan showing costs, grants and any finance options." },
  { q: "Am I eligible for funding?", a: "Eligibility depends on factors like your income, benefits status, property EPC rating and location. Many homeowners qualify for at least partial funding. The quickest way to find out is to request a free survey." },
  { q: "Are your installers accredited?", a: "Yes. We work only with a vetted network of MCS, Gas Safe and TrustMark accredited installers, so every installation meets the standards required for warranties and grant funding." },
  { q: "How long does an installation take?", a: "It varies by measure. Insulation is often completed in a day, a boiler swap in 1–2 days, and solar PV or a heat pump typically 1–3 days. Your surveyor will confirm timings in your plan." },
  { q: "What areas do you cover?", a: "We operate across the UK through our installer network. Enter your postcode when you request a survey and we'll confirm coverage in your area." },
];

export const STEPS = [
  { n: "01", title: "Free survey", text: "Book a no-obligation home survey. We assess your property and energy use." },
  { n: "02", title: "Your tailored plan", text: "Receive a clear plan of recommended measures, grants and finance options." },
  { n: "03", title: "We arrange funding", text: "We check grant eligibility and set up finance so there are no upfront costs." },
  { n: "04", title: "Accredited install", text: "Our vetted, accredited installers complete the work to the highest standard." },
];
